import { ENV, environmentVariable, isProduction } from '@application/env';
import type { ApplicationType, Language } from '@application/types';
import { CountryCode, DayOfWeek, DogBreederApplicationStatus } from '@gql/graphql';
import { StoreCardItemPromoType } from '@presentation/components';

// @index('./*.{tsx,ts}', f => `export * from '${f.path.replace("/index", "")}';`)
export * from './application';
export * from './articleTagColors';
export * from './cacheKeys';
export * from './cookieKeys';
export * from './countries';
export * from './icons';
export * from './language';
export * from './routes';
// @endindex

export const APPLICATION_STATUS_FOR_APPLICATION_TYPE: Record<
  ApplicationType,
  DogBreederApplicationStatus[]
> = {
  APPLICATIONS: [DogBreederApplicationStatus.CONTACT_AVAILABLE],
  OWNERS: [DogBreederApplicationStatus.DONE],
  WAITING_LIST: [DogBreederApplicationStatus.WAITING_LIST],
};

export const APPLICATION_STATUS_TO_SHOW_CONTACT_DETAILS = [
  DogBreederApplicationStatus.CONTACT_AVAILABLE,
  DogBreederApplicationStatus.DONE,
  DogBreederApplicationStatus.WAITING_LIST,
];

export const ASTERIKS_FOR_NAME = '*** ****';
export const ASTERIKS_FOR_PHONE_NUMBER = '******';
export const ASTERIKS_FOR_EMAIL = '******';

export const daysOfWeek: DayOfWeek[] = [
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
  DayOfWeek.SUNDAY,
];

export const WEBSITE_DOMAIN = isProduction() ? 'https://tipaw.com' : 'https://staging.tipaw.com';

export const FREE_APPLICATION_COUNTRIES = [
  CountryCode.FR,
  CountryCode.NL,
  CountryCode.CA,
  CountryCode.DE,
  CountryCode.CH,
  CountryCode.EU,
];

export const VET_ADVICE_CRISP_ID = isProduction()
  ? environmentVariable(ENV.VET_ADVICE_CRISP_PROD_ID)
  : environmentVariable(ENV.VET_ADVICE_CRISP_STAGING_ID);

export const VET_ADVICE_STRIPE_URL = isProduction()
  ? environmentVariable(ENV.VET_ADVICE_PROD_URL)
  : environmentVariable(ENV.VET_ADVICE_STAGING_URL);

export const TIPAW_STORE_URL: Record<Language, string> = {
  fr: 'https://store-tipaw.com/fr',
  nl: 'https://store-tipaw.com/nl',
  de: 'https://store-tipaw.com/',
  en: 'https://store-tipaw.com/',
};
export const TIPAW_STORE_SUPPLEMENTS_URL: Record<Language, string> = {
  fr: 'https://store-tipaw.com/fr/collections/dog-supplements',
  nl: 'https://store-tipaw.com/nl/collections/dog-supplements',
  de: 'https://store-tipaw.com/collections/dog-supplements',
  en: 'https://store-tipaw.com/collections/dog-supplements',
};
